// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Experiences_experiences__GqWbU .Experiences_experience-wrapper__c8RlN {
  width: 100%;
  background: white;
  padding: 15px 20px;
  border-radius: 5px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 25px;
}
.Experiences_experiences__GqWbU .Experiences_experience-wrapper__c8RlN .Experiences_experience__i8TRI .Experiences_experience-info__cB9CZ .Experiences_inst-name__-nYQA {
  font-weight: bold;
}
.Experiences_experiences__GqWbU .Experiences_experience-wrapper__c8RlN .Experiences_delete-experience__Wjbpz {
  margin-top: 5px;
}
.Experiences_experiences__GqWbU .Experiences_experience-wrapper__c8RlN .Experiences_delete-experience__Wjbpz svg {
  cursor: pointer;
}
.Experiences_experiences__GqWbU .Experiences_experience-wrapper__c8RlN .Experiences_delete-experience__Wjbpz svg path {
  stroke: red;
}
.Experiences_experiences__GqWbU .Experiences_add-button__G5Z1c {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Experiences/Experiences.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAGQ;EACE,iBAAA;AADV;AAKI;EACE,eAAA;AAHN;AAIM;EACE,eAAA;AAFR;AAGQ;EACE,WAAA;AADV;AAME;EACE,mBAAA;AAJJ","sourcesContent":[".experiences {\n  .experience-wrapper {\n    width: 100%;\n    background: white;\n    padding: 15px 20px;\n    border-radius: 5px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    margin-bottom: 25px;\n    .experience {\n      .experience-info {\n        .inst-name {\n          font-weight: bold;\n        }\n      }\n    }\n    .delete-experience {\n      margin-top: 5px;\n      svg {\n        cursor: pointer;\n        path {\n          stroke: red;\n        }\n      }\n    }\n  }\n  .add-button {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"experiences": `Experiences_experiences__GqWbU`,
	"experience-wrapper": `Experiences_experience-wrapper__c8RlN`,
	"experience": `Experiences_experience__i8TRI`,
	"experience-info": `Experiences_experience-info__cB9CZ`,
	"inst-name": `Experiences_inst-name__-nYQA`,
	"delete-experience": `Experiences_delete-experience__Wjbpz`,
	"add-button": `Experiences_add-button__G5Z1c`
};
export default ___CSS_LOADER_EXPORT___;
